import { req } from 'react-reqq-lite';

import { toastError } from 'modules/common/toast';
import { transformOrder } from 'modules/merchant/order-management/all-orders/transformer';

import * as c from './contants';

const MESSAGE_BY_STATUS = {
  DELIVERED: 'Already delivered',
  RECEIVED_ORDER: 'Already received',
};

export const validateOrder = (order_number, callback = () => {}) => {
  req.get({
    key: c.VALIDATE_ORDER,
    url: `/public/v1/orders/${order_number}`,
    transform: (res) => {
      const { status } = res;
      if (status === 'FOR_PICKUP' || status === 'IN_TRANSIT') {
        callback(status);
        return;
      }
      toastError(
        MESSAGE_BY_STATUS[status] || 'Order is not ready for delivery!'
      );
    },
  });
};

export const validateOTP = (order_number, params, callback = () => {}) => {
  req.get({
    key: c.VALIDATE_OTP,
    url: `/public/v1/orders/${order_number}`,
    params,
    onSuccess: () => {
      callback();
    },
    onError: () => {
      toastError('Invalid PIN');
    },
  });
};

export const getOrderDetails = (order_number, params, callback = () => {}) => {
  req.get({
    key: c.GET_ORDER_DETAILS,
    url: `/public/v1/orders/${order_number}`,
    params,
    transform: (res) => {
      const { data, included } = res;
      return transformOrder(data, included);
    },
    onSuccess: () => {
      callback();
    },
  });
};

export const confirmOrder = (order_number, callback = () => {}) => {
  req.put({
    key: c.CONFIRM_ORDER,
    url: `/public/v1/orders/${order_number}/confirm`,
    onSuccess: () => {
      req.set(c.GET_ORDER_DETAILS, (state) => {
        const data = state[c.GET_ORDER_DETAILS] || {};
        return {
          ...data,
          system_status: 'IN_TRANSIT',
        };
      });
      callback();
    },
  });
};

export const deliveredOrder = (order_number, callback = () => {}) => {
  req.put({
    key: c.DELIVERED_ORDER,
    url: `/public/v1/orders/${order_number}/delivered`,
    onSuccess: () => {
      callback();
    },
  });
};
